import { Link } from "@mui/material"
import AlertLoading from "../navigation/AlertLoading"
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export const PDFLink = ({spinner, href, label="PDF", unavailable="(unavailable)", ...props}) => {
    if (spinner) {
            return <AlertLoading spinner={spinner} inline />
    }
    return (
        href
        ?
        <Link href={href} {...props}>
            <PictureAsPdfIcon sx={{fontSize: '1em', pr: 1}} />
            {label}
        </Link>
        :
        <>
            <PictureAsPdfIcon sx={{fontSize: '1em', pr: 1}} />
            {label} {unavailable}
        </>
    )
}